import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { localStorageAvailable } from '@/utils';
import en from './locales/en.json';
import esES from './locales/es-ES.json';
import pt from './locales/pt.json';

const localStorageKey = 'translations-lang';

const defaultLang = localStorageAvailable() ? localStorage.getItem(localStorageKey) || '' : '';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      es: esES,
      pt,
      en,
    },
    lng: defaultLang, // if you're using a language detector, do not define the lng option
    fallbackLng: 'es',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export const changeLang = (lang: string) => {
  i18n.changeLanguage(lang);

  if (localStorageAvailable()) {
    localStorage.setItem(localStorageKey, lang);
  }
};

export default i18n;
